import api from "../api";

// Audit logları listeleme
export const getAuditLogs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/audit-logs", { params });
};

// Audit log detayı
export const getAuditLog = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/audit-logs/${id}`);
};

// Kullanıcıya ait audit logları
export const getUserAuditLogs = async (userId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `admin/audit-logs/user/${userId}`, { params });
};

// Audit log istatistikleri
export const getAuditLogStats = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/audit-logs/stats", { params });
};

